/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-02 21:02:40
 * @LastEditTime: 2019-07-24 14:49:04
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

/* 收藏接口 */
const conllectionUrl = `/website/personal/conllection/save`

const cancelConllectionUrl = `/website/personal/conllection/delete`

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

/* 预约看仓 */
const appointmentUrl = `/website/storage/appointment`

/* 查询字典接口 */
const getDictUrl = `/sys/dict/getDict`

// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }, {}))
    }
  })
}

/* 收藏货源 */
export function conllection(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + conllectionUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'saveCollection'
      }, param))
    }
  })
}
/* 取消收藏 */
export function cancelConllection(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + cancelConllectionUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'delCollection'
      }, param))
    }
  })
}

/* 预约看仓 */
export function appointment(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + appointmentUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'appointmentSave'
      }, param))
    }
  })
}
